const varErrors = require("./var_errors");
const { varReg, varNameReg, equalReg } = require("./regex/varDeclare");

const initialStructure = {
  name: null,
  _ref: null,
  filters: null,
  title: null,
  line: "",
  _line: {
    prevLine: "",
    position: null,
    content: ""
  },
  error: false,
  prettyLine: ""
};

export default function(raw) {
  let lines = raw.split("\n");
  const structuredLines = lines.reduce((acc, line, pos) => {
    const _line = {
      position: pos,
      prevLine: acc[pos - 1] ? acc[pos - 1].line : null,
      content: line
    };
    const LeftPadding = line.match(/^\s*/) ? line.match(/^\s*/)[0] : "";
    let structured = {
      ...initialStructure,
      line,
      _line
    };
    const isVarTag = varNameReg.test(line);
    const varMatch = varReg.exec(line);
    const isEqual = equalReg.test(line);

    if (varMatch) {
      if (isEqual) {
        const errorMsg = varErrors.invalidEqualSign(_line);
        throw new Error(errorMsg);
      }
      const serialized = prettyVarStructure(varMatch, _line);

      // reapply quotes if filter value includes special character
      if (/[-{}[\]!#>&%@]/.test(varMatch[2])) {
        serialized.filters = varMatch[2].trim();
      }
      structured = {
        ...structured,
        ...serialized,
        prettyLine: LeftPadding + beautifyVarTags(serialized)
      };
      return acc.concat(structured);
    }

    if (isVarTag) {
      const errorMsg = varErrors.invalidVarSyntax(_line);
      throw new Error(errorMsg);
    }

    return acc.concat(structured);
  }, []);
  window.__structuredLines = structuredLines;
  return structuredLines;
}

const beautifyVarTags = serializedLines => {
  const { name, filters } = serializedLines;
  if (!name) return null;
  let prettyDeclare = `{% var ${name}`;
  if (filters) prettyDeclare += ` ${filters.replace(/\s+/g, " ")}`;
  return prettyDeclare + " %}";
};

const prettyVarStructure = match => {
  let { filters, name } = match.groups;
  const hasName = name && name.trim().length;
  const hasFilters = filters && filters.trim().length;
  if (hasName) {
    name = `${name.replace(/'|"/g, "").trim()}`;
  }
  if (hasFilters) {
    filters = `${filters.replace(/'|"/g, "").trim()}`;
  }
  const structure = {
    var: true,
    name,
    filters,
    title: name
  };
  return structure;
};
